var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.configStore.electronMode)?_c('div',{staticClass:"icp"},[_c('img',{staticClass:"icp-icon",attrs:{"src":require("../../assets/image/icp_logo.png")}}),_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/"}},[_vm._v("豫ICP备2026010305号")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }